import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import styles from './RiskConcernSummary.css';

function RiskConcernSummary({ chapterLabel }) {
    return (
        <div className={styles.root}>
            <div className={styles.item}>
                <Icon name='bookOutline' />
                <div>
                    <p className={styles.label}>Starting with</p>
                    <p className={styles.value}>{chapterLabel}</p>
                </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.item}>
                <Icon name='calendar' />
                <div>
                    <p className={styles.label}>First chapter in</p>
                    <p className={styles.value}>2 weeks</p>
                </div>
            </div>
        </div>
    );
}

RiskConcernSummary.propTypes = {
    chapterLabel: PropTypes.string
};

export {
    RiskConcernSummary
};
